import * as XLSX from 'xlsx';
import { generateExcelFile__CLID8855 } from './generateExcelFile__CLID8855';
import { generateExcelFile_default } from './generateExcelFile_default';

export function generateExcelFile(textMessages, voiceMails, analytics, startDateStr, endDateStr, clid) {
  if (clid === 'CLID8855') {
    generateExcelFile__CLID8855(textMessages, voiceMails, analytics, startDateStr, endDateStr);
  } else {
    generateExcelFile_default(textMessages, voiceMails, analytics, startDateStr, endDateStr);
  }
};
